

const cookiesKey = {
	IS_REMEMBER: "IS_REMEMBER",

	TOKEN: "TOKEN",
	REFRESH_TOKEN: "REFRESH_TOKEN",
	REFRESH_TOKEN_EXPIRES_DATE: "REFRESH_TOKEN_EXPIRES_DATE",
	TOKEN_EXPIRES_DATE: "TOKEN_EXPIRES_DATE",
	TOKEN_EXPIRES_ON: "TOKEN_EXPIRES_ON",

	USER_ID: "USER_ID",
	USER_FULL_NAME: "USER_FULL_NAME",
	USER_ROLE_NAME: "USER_ROLE_NAME",
}

const defaultValue = {
	PLEASE_SELECT: "PLEASE_SELECT",
	SELECT_ALL: "SELECT_ALL",
	NONE_SELECT: "NONE_SELECT"
}



export {
	cookiesKey,
	defaultValue,
}


// WEBPACK FOOTER //
// ./src/constant.js